import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import { useUserStore } from './store/user'
import { setupGlobalErrorHandler } from './composables/useErrorHandler'

// Import global styles
import './styles/tokens.css'
import './styles/base.css'
import './styles/agency.css'

// Import FontAwesome
import '@fortawesome/fontawesome-free/css/all.min.css'

// Import root component
import App from './App.vue'

const app = createApp(App)

// Install plugins
app.use(createPinia())
app.use(router)

// Setup global error handling
setupGlobalErrorHandler()

// Vue error handler
app.config.errorHandler = (error, instance, info) => {
  console.error('Vue Error:', error, info)
  // Error will be handled by global error handler
}

// Initialize auth before mounting
const initializeApp = async () => {
  const userStore = useUserStore()
  
  try {
    // Wait for auth state to be determined
    await userStore.initAuth()
  } catch (error) {
    console.error('Failed to initialize auth:', error)
  } finally {
    // Mount the app regardless of auth status
    app.mount('#app')
  }
}

// Start the application
initializeApp()
